/**
 * Sede activa del ADMIN (multi sede). Se guarda en localStorage y Axios la envía en X-Sede-Id.
 * Sin sede guardada el ADMIN ve el consolidado de todas sus sedes. El OPERADOR no elige:
 * el backend siempre usa la sede asignada.
 */
const SEDE_KEY = 'sedeId';

export const getSelectedSede = (): string | null => {
    try {
        return localStorage.getItem(SEDE_KEY);
    } catch {
        return null;
    }
};

export const setSelectedSede = (sedeId: string | null) => {
    try {
        if (sedeId) localStorage.setItem(SEDE_KEY, sedeId);
        else localStorage.removeItem(SEDE_KEY);
    } catch {
        // Sin almacenamiento disponible: se trabaja en el consolidado
    }
};

/**
 * Cambia la sede y recarga para que todas las pantallas consulten la nueva
 */
export const switchSede = (sedeId: string | null) => {
    setSelectedSede(sedeId);
    window.location.reload();
};

/**
 * Deja la sede guardada consistente con las sedes a las que el usuario tiene acceso
 */
export const reconcileSede = (sedes: { id: string }[] = [], assignedSedeId?: string | null) => {
    const stored = getSelectedSede();
    if (assignedSedeId && sedes.length <= 1) {
        setSelectedSede(assignedSedeId);
    } else if (stored && !sedes.some((s) => s.id === stored)) {
        setSelectedSede(sedes.length === 1 ? sedes[0].id : null);
    } else if (!stored && sedes.length === 1) {
        setSelectedSede(sedes[0].id);
    }
};
